// extracted by mini-css-extract-plugin
module.exports = {"avatar":"fk","avatarImg":"fl"};